import { gql } from "@apollo/client";

const GET_REJECTION_EMAIL_TEMPLATES = gql`
  query getRejectionEmailTemplates {
    rejectionEmailTemplatesCollection {
      items {
        id
        title
        content
      }
    }
  }
`;

export default GET_REJECTION_EMAIL_TEMPLATES;
